import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import { t } from "@/i18n-js/instance";

export const defaultData: BaseBlock = {
  id: "form-dropdown-block",
  type: "FormDropdownBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Dropdown",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
    options: {
      prop: "other",
      type: "choice-options",
      value: [
        {
          id: "1",
          value: t("builder_ui.prop_type.option_number", { number: 1 }),
        },
        {
          id: "2",
          value: t("builder_ui.prop_type.option_number", { number: 2 }),
        },
        {
          id: "3",
          value: t("builder_ui.prop_type.option_number", { number: 3 }),
        },
      ],
    },
  },
};
